const CONSTANTS = {
    NO_REPLY_EMAIL: "noreply@readyrx.com",
    SUPPORT_EMAIL: "clientsuccess@readyrx.com",
    SUPPORT_PHONE: "(310) 878-1003",
    CANCEL_PHONE: "(424) 842-4583",
    CANCEL_URL: "https://app.readyrx.com/subscription-cancel",
    CANCEL_EMAIL: "cancel@readyrx.com",
    CANCEL_ADDRESS_1: "1712 Pioneer Ave Ste 115",
    CANCEL_ADDRESS_2: "Cheyenne, WY, 82001",
    COMPANY_ADDRESS_1: "1712 Pioneer Ave Ste 115",
    COMPANY_ADDRESS_2: "Cheyenne, WY, 82001",
    LEGAL_EMAIL: "legal@readyrx.com",
    INSURANCE_EMAIL: "insurance@readyrx.com", // for updating insurance info
    PRIVACY_EMAIL: "privacy@readyrx.com",
    TERMS_URL: "https://app.readyrx.com/terms",
    PRIVACY_URL: "https://app.readyrx.com/privacy",
    SUBSCRIPTION_AGREEMENT_URL: "https://app.readyrx.com/lab-test-order-agreement",
    COMMUNICATION_POLICY_URL: "https://app.readyrx.com/communication-policy",
    COOKIE_POLICY_URL: "https://app.readyrx.com/cookies",
    UPDATE_INSURANCE_URL: "https://app.readyrx.com/insurance-update",
    LANDING_URL: "https://app.readyrx.com",
    CONSENT_URL: "https://app.readyrx.com/consent",
    CONTACT_URL: "https://app.readyrx.com/contact",
    COMPANY_NAME: "ReadyRx",
    COMPANY_LEGAL_NAME: "Executive Medical, LLC"
};

export default CONSTANTS;